/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of the integrity of the device.
 */
export enum DeviceIntegrityStatusSummaryType {
  DeviceIntegrityStatusVerified = 'Verified',
  DeviceIntegrityStatusFailed = 'Failed',
  DeviceIntegrityStatusUnknown = 'Unknown',
  DeviceIntegrityStatusUnsupported = 'Unsupported',
}
